import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["scrollable"];

  /**
   * Restores the scroll position and sets up an event listener for saving it before navigation.
   */
  connect() {
    this.scrollKey = this.scrollableTarget.dataset.scrollKey;

    const scrollPosition = sessionStorage.getItem(this.scrollKey);
    if (scrollPosition) {
      this.scrollableTarget.scrollTop = scrollPosition;
    }

    document.addEventListener(
      "turbo:before-render",
      this.saveScrollPosition.bind(this)
    );
  }

  /**
   * Removes the event listener to avoid memory leaks when the controller is disconnected.
   */
  disconnect() {
    document.removeEventListener(
      "turbo:before-render",
      this.saveScrollPosition.bind(this)
    );
  }

  /**
   * Saves the current scroll position in session storage.
   */
  saveScrollPosition() {
    sessionStorage.setItem(this.scrollKey, this.scrollableTarget.scrollTop);
  }
}
